<header class="brand-header-light">
	<div [ngClass]="{'container': !isIdentificationRoute()}">
		<div class="row " [ngClass]="{'justify-content-sm-center': !isIdentificationRoute()}">
			<div class="col-xs-10" [ngClass]="{' col-sm-6 col-md-5 col-lg-4': !isIdentificationRoute()}">
				<a class="top-logo" attr.href="{{ 'links.uoc.url' | translate }}">
					<img src="assets/img/logo-uoc-default.png" alt="{{ 'header.aa-uoc-logo' | translate }}">
				</a>
				<p class="top-slogan ruler ruler--secondary ruler--double">Universitat Oberta <br aria-hidden="true"> de Catalunya</p>
			</div>
			<div class="col-xs-2" [ngClass]="{'col-sm-1 col-md-1': !isIdentificationRoute()}">
				<div class="top-lang ruler ruler--secondary ruler--double">
          <!-- <div class="col-xs-2 col-sm-1 col-md-1 hidden-xs hidden-sm"> -->
            <!-- <div class="top-lang ruler ruler--secondary ruler--double"> -->
              <div data-dropdown="" class="dropdown language-drop-down float-left">
                <button data-dropdown-trigger="" attr.aria-label="{{ 'header.aa-change-lang' | translate }}"
                        aria-expanded="false" aria-controls="dropdown__language-content"
                        class="btn btn--primary dropdown__trigger dropdown-button-header p-0">{{ getSelectedLang() | uppercase }}
                  <span aria-hidden="true" class="icon icon--arrow-down icon--small bold m-left-x2"></span>
                </button>
                <div class="dropdown__content dropdown__list" id="dropdown__language-content">
                  <ul data-animated="false">
                    <li class="dropdown__item" *ngFor="let l of languages;" [ngClass]="{'is-active': isSelectedLang(l)}"
                        [attr.aria-current]="isSelectedLang(l)">
                      <a href="#" lang="{{l.lang}}" class="dropdown__link" (click)="useLang(l)"
                         data-dropdown-trigger>{{l.name}}</a>
                    </li>
                  </ul>
                  <button attr.aria-label="{{ 'header.aa-close-lang' | translate }}"
                          aria-controls="dropdown__language-content"
                          data-dropdown-trigger="" class="btn btn--primary close">
                    <span class="icon icon--close" aria-hidden="true"></span></button>
                </div>
              </div>
            <!-- </div> -->
          <!-- </div> -->

				</div>
			</div>
		</div>
	</div>
</header>
